export default {
    data: () => ({
        tableExpanded: false, tableViewportHeight: null, reportDetailsColumn: null,
        reportDetailsVisible: false
    }),
    mounted() {
        window.addEventListener('resize', this.scheduleTableLayout);
        window.addEventListener('scroll', this.scheduleTableLayout, {passive: true});
        document.addEventListener('keydown', this.handleTableEscape);
        if (typeof ResizeObserver !== 'undefined') {
            this._layoutObserver = new ResizeObserver(this.scheduleTableLayout);
            this._layoutObserver.observe(this.$el);
        }
        this.scheduleTableLayout();
    },
    updated() { this.scheduleTableLayout(); },
    beforeDestroy() {
        window.removeEventListener('resize', this.scheduleTableLayout);
        window.removeEventListener('scroll', this.scheduleTableLayout);
        document.removeEventListener('keydown', this.handleTableEscape);
        if (this._layoutObserver) this._layoutObserver.disconnect();
        if (this._layoutFrame) cancelAnimationFrame(this._layoutFrame);
        this.restoreTablePage();
    },
    watch: {
        '$route.fullPath'() { this.setTableExpanded(false); },
        isCompactViewport(value) { if (value && !this.isMobileFullMonthView) this.setTableExpanded(false); },
        isMobileFullMonthView(value) { if (!value && this.isCompactViewport) this.setTableExpanded(false); }
    },
    computed: {
        reportDetailsDays() {
            return this.reportDetailsColumn ? this.reportColumnDays(this.reportDetailsColumn) : this.monthDays;
        }
    },
    methods: {
        openReportDetails(column = null) {
            this.reportDetailsColumn = column;
            this.reportDetailsVisible = true;
        },
        scheduleTableLayout() {
            if (this._layoutFrame) return;
            this._layoutFrame = requestAnimationFrame(() => {
                this._layoutFrame = null;
                const viewport = this.$refs.monthScroll;
                if (!viewport) return;
                const rect = viewport.getBoundingClientRect();
                // On the ordinary page leave enough content to scroll the table into view.
                const height = Math.max(280, Math.floor(window.innerHeight - Math.max(0, rect.top) - 12));
                if (this.tableViewportHeight !== height) this.tableViewportHeight = height;
                if (this.$refs.monthRows) this.$refs.monthRows.schedule();
            });
        },
        restoreTablePage() {
            if (!this._tablePage) return;
            const saved = this._tablePage;
            this._tablePage = null;
            document.body.style.overflow = saved.overflow;
            window.scrollTo(saved.x, saved.y);
        },
        setTableExpanded(value) {
            if (value === this.tableExpanded) return;
            const viewport = this.$refs.monthScroll;
            const position = viewport && {top: viewport.scrollTop, left: viewport.scrollLeft};
            if (value) {
                this._tablePage = {overflow: document.body.style.overflow, x: window.scrollX, y: window.scrollY};
                document.body.style.overflow = 'hidden';
            }
            this.tableExpanded = value;
            this.$nextTick(() => {
                if (!value) this.restoreTablePage();
                if (viewport && position) {
                    viewport.scrollTop = position.top;
                    viewport.scrollLeft = position.left;
                }
                this.scheduleTableLayout();
                if (this._gridFrame) this._gridFrame.schedule();
            });
        },
        handleTableEscape(event) {
            if (event.key !== 'Escape' || !this.tableExpanded || event.defaultPrevented) return;
            if (document.querySelector('.modal.show, .modal[aria-modal="true"], .b-sidebar.show')) return;
            // Bootstrap may start closing a modal before this document listener runs.
            // The original event target still identifies that Escape's owner.
            if (event.target && event.target.closest('.modal, .b-sidebar, input, textarea, select, [contenteditable="true"]')) return;
            if (this._cellPicker && this._cellPicker.opened) return;
            this.setTableExpanded(false);
            event.preventDefault();
        }
    }
};
